import React from "react"

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    this.setState({ hasError: true })
  }

  render() {
    if (this.state.hasError) {
      if (this.props.errorComponent) return this.props.errorComponent

      return <> </>
    }

    return this.props.children
  }
}

export default ErrorBoundary
